import { useCallback, useContext } from "react";
import useTranslate from "hooks/useTranslate";
import MessageDialogContext from "context/MessageDialogContext";

export default function useStoreDetailsIssueDialog() {
  const { translate: taxTranslate } = useTranslate("admin.taxes");
  const { setActionCloseMessageInfo } = useContext(MessageDialogContext);

  return useCallback(() => {
    setActionCloseMessageInfo(
      taxTranslate("storeDetailsIssueTitle"),
      taxTranslate("storeDetailsIssueBody"),
      "close",
    );
  }, [setActionCloseMessageInfo, taxTranslate]);
}
